import { render } from "./ActiveRequestsView.vue?vue&type=template&id=61aa348e&scoped=true"
import script from "./ActiveRequestsView.vue?vue&type=script&lang=js"
export * from "./ActiveRequestsView.vue?vue&type=script&lang=js"

import "./ActiveRequestsView.vue?vue&type=style&index=0&id=61aa348e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61aa348e"]])

export default __exports__